export default __webpack_public_path__ + "static/media/18.17aa6aae.jpg";